"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

/**
 *
 * @param {*} value
 *
 * takes in an initial value to be stored
 * @returns- previous value
 * Whatever value was initially passed into the useRef Hook is saved to the current property of the ref object.
 */
var usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};

var _default = usePrevious;
exports["default"] = _default;